import React, {useCallback, useEffect, useImperativeHandle, useRef, useState} from 'react';
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import PrintBody from "./print-components/print-body.jsx";
import {preparePrintableImages, releasePrintableImages} from "./print-components/print-image-utils.js";
import NoResults from "./no-results.jsx";
import {Template} from "../../../../components/template/template.jsx";

const waitForBrowserPaint = () => new Promise((resolve) => {
    if (typeof requestAnimationFrame !== "function") {
        setTimeout(resolve, 0);
        return;
    }

    requestAnimationFrame(() => requestAnimationFrame(resolve));
});

const PrintTable = ({headerSelected, printComponentRef, setIsLoading, printPassages, filtersToPrint}) => {
    const templateRef = useRef(null);
    const preparedPassagesRef = useRef([]);
    const [preparedPassages, setPreparedPassages] = useState([]);

    const clearPreparedPassages = useCallback(() => {
        releasePrintableImages(preparedPassagesRef.current);
        preparedPassagesRef.current = [];
        setPreparedPassages([]);
    }, []);

    const handlePrint = useCallback(async () => {
        if (!Array.isArray(printPassages)) {
            if (setIsLoading) setIsLoading(false);
            return;
        }

        if (setIsLoading) setIsLoading(true);

        try {
            releasePrintableImages(preparedPassagesRef.current);
            preparedPassagesRef.current = [];

            const passagesWithImages = await preparePrintableImages(printPassages);

            preparedPassagesRef.current = passagesWithImages;
            setPreparedPassages(passagesWithImages);

            await waitForBrowserPaint();

            if (templateRef.current?.print) {
                templateRef.current.print();
                return;
            }
        } catch (error) {
            console.error("Erro ao preparar imagens para impressão.", error);
        }

        if (setIsLoading) setIsLoading(false);
    }, [printPassages, setIsLoading]);

    useImperativeHandle(printComponentRef, () => ({print: handlePrint}), [handlePrint]);

    useEffect(() => () => {
        releasePrintableImages(preparedPassagesRef.current);
    }, []);

    return (
        <div className="hidden print:block">
            <Template.Title browserTitle={'Pesquisa de passagens - Minha corporação'}/>
            <PrintTemplate entity={headerSelected} title={"Relatório de pesquisa de passagem"} browserTitle={'Pesquisa de passagens - Minha corporação'} ref={templateRef} setIsPrinting={setIsLoading} onAfterPrint={clearPreparedPassages}>

                <div className="bg-white">
                    <div id="filters-print" className={'transform !-translate-y-[8.5px]'}></div>
                    <div className="w-full -mt-2"><span dangerouslySetInnerHTML={{ __html: filtersToPrint }} /></div>
                    <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full print:mt-2"/>
                    {
                        preparedPassages.length > 0 ?
                            <PrintBody passages={preparedPassages}/>
                            :
                            <NoResults passages={preparedPassages}/>
                    }
                </div>

            </PrintTemplate>
        </div>
    );
};

export default PrintTable;
